import _ from 'underscore'
import Backbone from 'backbone'

export var eventBus = _.extend({}, Backbone.Events)
